"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KansaAnswerRegisterEntry = KansaAnswerRegisterEntry;
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _openSSO = require("01_core/logics/openSSO");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../common/components/materials/KansaTgtJigyoBasicInfo"));
var _KansaAnswerConsts = require("../common/consts/KansaAnswerConsts");
var _kansaProgressActions = require("../progress/kansaProgressActions");
var _KansaAnswerTrailList = _interopRequireDefault(require("./KansaAnswerTrailList"));
var _AnswerTable = _interopRequireDefault(require("./components/AnswerTable"));
var _ButtonFooter = _interopRequireDefault(require("./components/ButtonFooter"));
var _KakuninKekka = _interopRequireDefault(require("./components/KakuninKekka"));
var _KansaBasicLabel = _interopRequireDefault(require("./components/KansaBasicLabel.js"));
var _kansaAnswerActions = require("./kansaAnswerActions");
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査回答登録画面
 */
const ACTIONS_PT = 0.5;
const ACTIONS_PL = 2;
const ACTIONS_PB = 2;
const ACTIONS_PR = 2;
const StyledPreviousButton = (0, _styles.styled)(_CButton.default)({
  display: 'block',
  margin: '0 0 0 auto'
});
const StyledCardActions = (0, _styles.styled)(_material.CardActions)(_ref => {
  let {
    theme
  } = _ref;
  return {
    textAlign: 'right',
    paddingTop: theme.spacing(ACTIONS_PT),
    paddingLeft: theme.spacing(ACTIONS_PL),
    paddingBottom: theme.spacing(ACTIONS_PB),
    paddingRight: theme.spacing(ACTIONS_PR)
  };
});
function KansaAnswerRegisterEntry(props) {
  const {
    intl,
    setEntry,
    getCodeItems,
    getCodeName,
    listState,
    kansaInfo,
    entries,
    mailFlg,
    gyomuCd,
    changePushFlg,
    returnBtn,
    openInfoBar,
    kansaTgtNendoMaxPoints,
    kansaTgtJigyoBasicInfo,
    setEntryResult,
    setSearchTrailResult,
    setKansaTgtJigyoBasicInfo,
    callAPI,
    clearDirty,
    setMailErrMsg,
    setContent,
    goMain,
    isProgress,
    goProgressMain,
    openConfirm,
    setEntryValueHyoka
  } = props;
  const [svData, setSvData] = (0, _react.useState)([]);
  const [btnKindKbn, setBtnKindKbn] = (0, _react.useState)('');
  const [zennendoSimpleFlg, setZennendoSimpleFlg] = (0, _react.useState)('');
  const [zennendoKansaAnsStsCd, setZennendoKansaAnsStsCd] = (0, _react.useState)('');
  const [zennenFlg] = (0, _react.useState)(false);
  const didInitValuesRef = (0, _react.useRef)(false);
  const didInitialFetchRef = (0, _react.useRef)(false);

  /**
   * RHF フィールド名ヘルパー
   */
  const fieldName = (key, chosaNo) => "".concat(key, "_").concat(chosaNo);

  /**
   * RHF defaultValues を生成
   */
  const createDefaultValues = (0, _react.useCallback)((ls, btn) => {
    const values = {
      btnKindKbn: btn || ''
    };
    Object.keys(ls || {}).forEach(k => {
      var _row$kakuninKekkaCd, _row$kakuninHosoku, _row$hakkenjikoBunrui, _row$hakkenjiko, _row$seijukudoHyoka;
      const row = ls[k];
      const vKekka = typeof row.kakuninKekkaCd === 'string' ? row.kakuninKekkaCd.trim() : (_row$kakuninKekkaCd = row.kakuninKekkaCd) !== null && _row$kakuninKekkaCd !== void 0 ? _row$kakuninKekkaCd : '';
      values[fieldName('kakuninKekkaCd', row.chosaNo)] = vKekka;
      values[fieldName('kakuninHosoku', row.chosaNo)] = (_row$kakuninHosoku = row.kakuninHosoku) !== null && _row$kakuninHosoku !== void 0 ? _row$kakuninHosoku : '';
      values[fieldName('hakkenjikoBunruiCd', row.chosaNo)] = (_row$hakkenjikoBunrui = row.hakkenjikoBunruiCd) !== null && _row$hakkenjikoBunrui !== void 0 ? _row$hakkenjikoBunrui : '';
      values[fieldName('hakkenjiko', row.chosaNo)] = (_row$hakkenjiko = row.hakkenjiko) !== null && _row$hakkenjiko !== void 0 ? _row$hakkenjiko : '';
      values[fieldName('seijukudoHyoka', row.chosaNo)] = (_row$seijukudoHyoka = row.seijukudoHyoka) !== null && _row$seijukudoHyoka !== void 0 ? _row$seijukudoHyoka : '';
      values[fieldName('dispFlg', row.chosaNo)] = !!row.dispFlg;
    });
    return values;
  }, []);

  /**
   * RHF＋Yup スキーマ生成
   */
  const shape = (0, _react.useMemo)(() => {
    const s = {};
    s.btnKindKbn = (0, _validationHelpers.optionalString)();
    Object.keys(listState || {}).forEach(k => {
      const row = listState[k];
      const no = row.chosaNo;
      s[fieldName('kakuninKekkaCd', no)] = (0, _validationHelpers.requiredSelectWhen)(intl, ['btnKindKbn'], btn => btn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE || btn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_HIKANSA);
      s[fieldName('kakuninHosoku', no)] = (0, _validationHelpers.optionalStringTrimMax)(intl, 200);
      s[fieldName('hakkenjikoBunruiCd', no)] = (0, _validationHelpers.optionalString)();
      s[fieldName('hakkenjiko', no)] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ['btnKindKbn', fieldName('hakkenjikoBunruiCd', no)], (btn, cls) => btn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE && cls !== _CodeConsts.CODE.KANSA_HKN_BNR.CODE_0, 200);
      s[fieldName('dispFlg', no)] = (0, _validationHelpers.optionalBoolean)();
      s[fieldName('seijukudoHyoka', no)] = (0, _validationHelpers.numberAsStringWhenRange)(intl, ['btnKindKbn', fieldName('dispFlg', no)], (btn, disp) => btn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE && !!disp, {
        min: 1,
        max: kansaTgtNendoMaxPoints,
        decimalPlaces: 1
      });
    });
    return s;
  }, [listState, kansaTgtNendoMaxPoints, intl]);

  /**
   * RHF 初期値の生成
   */
  const defaultValues = (0, _react.useMemo)(() => createDefaultValues(listState, btnKindKbn), [createDefaultValues, listState, btnKindKbn]);

  /**
   * RHFハンドルの取得
   */
  const {
    handleSubmit,
    setValue,
    formState,
    reset,
    register,
    getValues
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape
  });
  const {
    errors,
    submitCount
  } = formState;

  /**
   * 監査回答情報一時配列格納（見出しラベル編集）
   */
  const thisCreateData = (0, _react.useCallback)(data => {
    const tmpState = {
      svData: [],
      btnKindKbn,
      zennendoSimpleFlg,
      zennendoKansaAnsStsCd,
      zennenFlg
    };
    (0, _KansaBasicLabel.default)(data, tmpState);
    setSvData(tmpState.svData);
  }, [btnKindKbn, zennendoSimpleFlg, zennendoKansaAnsStsCd, zennenFlg]);

  /**
   * 監査回答情報検索処理
   */
  const searchAnswerData = (0, _react.useCallback)(() => {
    // 監査対象基本情報取得
    callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setKansaTgtJigyoBasicInfo(response.data);
        const basic = response.data;
        // 前年度監査対象基本情報取得
        if (basic !== null && basic !== void 0 && basic.zennendoKansaTgtNendo && basic !== null && basic !== void 0 && basic.zennendoKansaTgtJigyoId) {
          const sendDataZennen = {
            kansaTgtNendo: basic.zennendoKansaTgtNendo,
            kansaTgtJigyoId: basic.zennendoKansaTgtJigyoId
          };
          callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, sendDataZennen).then(responseZennen => {
            if (responseZennen.status === _APIs.STATUS.SUCCESS) {
              const prev = responseZennen.data;
              // 前年度の監査対象基本情報.簡易フラグと監査回答状況コードを取得する（nullガード）
              if (prev) {
                setZennendoSimpleFlg(prev.simpleFlg);
                setZennendoKansaAnsStsCd(prev.kansaAnsStsCd);
              } else {
                setZennendoSimpleFlg('');
                setZennendoKansaAnsStsCd('');
              }
            }
          }).catch(e => {
            if ((e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.CALLING && (e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED) {
              var _e$message;
              openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, String((_e$message = e === null || e === void 0 ? void 0 : e.message) !== null && _e$message !== void 0 ? _e$message : e));
            }
          });
        } else {
          // 前年度キーが無い場合は既定値へクリア
          setZennendoSimpleFlg('');
          setZennendoKansaAnsStsCd('');
        }
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.CALLING && (e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED) {
        var _e$message2;
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, String((_e$message2 = e === null || e === void 0 ? void 0 : e.message) !== null && _e$message2 !== void 0 ? _e$message2 : e));
      }
    });

    // 監査回答情報初期情報検索
    callAPI(_APIs.KANSA_ANSWER_INIT_SEARCH, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        thisCreateData(response.data);
        setEntryResult(response.data);
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.CALLING && (e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED) {
        var _e$message3;
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, String((_e$message3 = e === null || e === void 0 ? void 0 : e.message) !== null && _e$message3 !== void 0 ? _e$message3 : e));
      }
    });
  }, [callAPI, kansaInfo, setKansaTgtJigyoBasicInfo, openInfoBar, thisCreateData, setEntryResult]);

  /**
   * 監査証跡情報検索処理
   */
  const searchTrailData = (0, _react.useCallback)(() => {
    callAPI(_APIs.KANSA_ANSWER_TRAIL_SEARCH, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setSearchTrailResult(response.data);
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.CALLING && (e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED) {
        var _e$message4;
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, String((_e$message4 = e === null || e === void 0 ? void 0 : e.message) !== null && _e$message4 !== void 0 ? _e$message4 : e));
      }
    });
  }, [callAPI, kansaInfo, setSearchTrailResult, openInfoBar]);

  /**
   * 初期ロード（監査回答情報＋証跡情報）
   */
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
    if (!didInitialFetchRef.current) {
      didInitialFetchRef.current = true;
      searchAnswerData();
      searchTrailData();
    }
  }, [searchAnswerData, searchTrailData]);

  /**
   * 初期データ取得後に一度だけRHF値を同期（以降はresetしない）
   */
  (0, _react.useEffect)(() => {
    if (!didInitValuesRef.current && listState && Object.keys(listState).length > 0) {
      reset(createDefaultValues(listState, btnKindKbn));
      didInitValuesRef.current = true;
    }
  }, [listState, reset, createDefaultValues, btnKindKbn]);

  // 差分のみ同期（defaultValues ではなく現在値と比較）
  (0, _react.useEffect)(() => {
    if (didInitValuesRef.current && listState) {
      const current = getValues();
      Object.keys(listState).forEach(k => {
        var _row$kakuninKekkaCd2, _row$kakuninHosoku2, _row$hakkenjikoBunrui2, _row$hakkenjiko2, _row$seijukudoHyoka2;
        const row = listState[k];
        const no = row.chosaNo;
        const vKekka = typeof row.kakuninKekkaCd === 'string' ? row.kakuninKekkaCd.trim() : (_row$kakuninKekkaCd2 = row.kakuninKekkaCd) !== null && _row$kakuninKekkaCd2 !== void 0 ? _row$kakuninKekkaCd2 : '';
        const vHosoku = (_row$kakuninHosoku2 = row.kakuninHosoku) !== null && _row$kakuninHosoku2 !== void 0 ? _row$kakuninHosoku2 : '';
        const vBunrui = (_row$hakkenjikoBunrui2 = row.hakkenjikoBunruiCd) !== null && _row$hakkenjikoBunrui2 !== void 0 ? _row$hakkenjikoBunrui2 : '';
        const vHakken = (_row$hakkenjiko2 = row.hakkenjiko) !== null && _row$hakkenjiko2 !== void 0 ? _row$hakkenjiko2 : '';
        const vHyoka = (_row$seijukudoHyoka2 = row.seijukudoHyoka) !== null && _row$seijukudoHyoka2 !== void 0 ? _row$seijukudoHyoka2 : '';
        const vDisp = !!row.dispFlg;
        const nKekka = fieldName('kakuninKekkaCd', no);
        const nHosoku = fieldName('kakuninHosoku', no);
        const nBunrui = fieldName('hakkenjikoBunruiCd', no);
        const nHakken = fieldName('hakkenjiko', no);
        const nHyoka = fieldName('seijukudoHyoka', no);
        const nDisp = fieldName('dispFlg', no);
        if (current[nKekka] !== vKekka) setValue(nKekka, vKekka, {
          shouldValidate: false,
          shouldDirty: false
        });
        if (current[nHosoku] !== vHosoku) setValue(nHosoku, vHosoku, {
          shouldValidate: false,
          shouldDirty: false
        });
        if (current[nBunrui] !== vBunrui) setValue(nBunrui, vBunrui, {
          shouldValidate: false,
          shouldDirty: false
        });
        if (current[nHakken] !== vHakken) setValue(nHakken, vHakken, {
          shouldValidate: false,
          shouldDirty: false
        });
        if (current[nHyoka] !== vHyoka) setValue(nHyoka, vHyoka, {
          shouldValidate: false,
          shouldDirty: false
        });
        if (current[nDisp] !== vDisp) setValue(nDisp, vDisp, {
          shouldValidate: false,
          shouldDirty: false
        });
      });
    }
  }, [listState, setValue, getValues]);
  (0, _react.useEffect)(() => {
    if (listState && Object.keys(listState).length > 0) {
      register('btnKindKbn');
      Object.keys(listState).forEach(k => {
        const no = listState[k].chosaNo;
        register(fieldName('kakuninKekkaCd', no));
        register(fieldName('kakuninHosoku', no));
        register(fieldName('hakkenjikoBunruiCd', no));
        register(fieldName('hakkenjiko', no));
        register(fieldName('seijukudoHyoka', no));
        register(fieldName('dispFlg', no));
      });
    }
  }, [listState, register]);
  const onClickOverridePreviousEntries = (0, _react.useCallback)(() => {
    const prevInfo = kansaTgtJigyoBasicInfo || {};
    clearDirty();
    const params = {
      keyKansaTgtNendo: prevInfo.zennendoKansaTgtNendo,
      keyKansaTgtJigyoId: prevInfo.zennendoKansaTgtJigyoId,
      keyDispContent: _kansaAnswerActions.CONTENTS.ZENNENDO
    };
    (0, _openSSO.openSubWindowWithParams)('kansa_answer', _KansaAnswerConsts.CONSTS.COMMON_SUB_WINDOW_KEY + '_refer', '', '', params).focus();
  }, [clearDirty, kansaTgtJigyoBasicInfo]);

  /**
   * ボタンクリック時（回答一時保存、回答登録、被監査部門回答登録）
   */
  const onButtonClick = (0, _react.useCallback)(kind => {
    setBtnKindKbn(kind);
    setValue('btnKindKbn', kind, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setValue]);

  /**
   * 登録処理.
   */
  const updateSetting = (0, _react.useCallback)(() => {
    // 更新データの作成
    let updateData = [];
    for (let key in listState) {
      updateData.push({
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
        btnKind: btnKindKbn,
        chosaNo: listState[key].chosaNo,
        chosaColumnCd: listState[key].chosaColumnCd,
        kakuninKekkaCd: listState[key].kakuninKekkaCd,
        kakuninHosoku: listState[key].kakuninHosoku,
        hakkenjikoBunruiCd: listState[key].hakkenjikoBunruiCd,
        hakkenjiko: listState[key].hakkenjiko,
        seijukudoHyoka: listState[key].seijukudoHyoka,
        dispFlg: listState[key].dispFlg
      });
    }
    let apiNm = '';
    if (_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE === btnKindKbn) {
      // 回答登録の場合
      apiNm = _APIs.KANSA_ANSWER_REGIST;
    } else if (_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_HIKANSA === btnKindKbn) {
      // 被監査部門回答登録の場合
      apiNm = _APIs.KANSA_ANSWER_REGIST_HIKANSA;
    } else if (_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_TEMP === btnKindKbn) {
      // 回答一時保存の場合
      apiNm = _APIs.KANSA_ANSWER_REGIST_TEMPSAVE;
    }
    callAPI(apiNm, {
      items: updateData,
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      pushFlg: mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2 && (entries === null || entries === void 0 ? void 0 : entries.pushFlg),
      btnKind: btnKindKbn,
      maxPoints: kansaTgtNendoMaxPoints
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        clearDirty();
        // 回答一時保存の押下
        if (_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_TEMP === btnKindKbn) {
          if (isProgress) {
            // 監査進捗状況の検索結果一覧からの遷移の場合
            goProgressMain(true);
          } else {
            // 監査回答の検索結果一覧からの遷移の場合
            goMain(true);
          }
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_ANSWER_TEMP_SAVE
          }));
        } else {
          var _response$message;
          setContent(_kansaAnswerActions.CONTENTS.RESULT);
          setMailErrMsg(String((_response$message = response.message) !== null && _response$message !== void 0 ? _response$message : ''));
        }
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.CALLING && (e === null || e === void 0 ? void 0 : e.reason) !== _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED) {
        var _e$message5;
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, String((_e$message5 = e === null || e === void 0 ? void 0 : e.message) !== null && _e$message5 !== void 0 ? _e$message5 : e));
      }
    });
  }, [callAPI, listState, kansaInfo, btnKindKbn, mailFlg, gyomuCd, entries, kansaTgtNendoMaxPoints, clearDirty, isProgress, goProgressMain, goMain, openInfoBar, intl, setContent, setMailErrMsg]);

  /**
   * 確認ダイアログ
   */
  const openConfirmDialog = (0, _react.useCallback)(() => {
    if (btnKindKbn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_TEMP) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
      }), () => {
        updateSetting();
      });
    } else if (btnKindKbn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE || btnKindKbn === _KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_HIKANSA) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE
      }), mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2 && (entries === null || entries === void 0 ? void 0 : entries.pushFlg) && intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEND_MAIL_CONFIRM
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_KANSA_BUMON
        })
      })), () => {
        updateSetting();
      });
    }
  }, [btnKindKbn, intl, updateSetting, openConfirm, mailFlg, gyomuCd, entries]);

  /**
   * 成熟度評価（参考値の算出）
   */
  const pointCalc = (0, _react.useCallback)((chosaNo, value, chosaColumnCd, standardPoints, kind) => {
    var _listState$chosaNo, _listState$chosaNo2, _listState$svChosaNo;
    let kisoPoint = 0;
    let katenPoint = 0;
    let confirmFlg = true;
    const currentKekka = (_listState$chosaNo = listState[chosaNo]) === null || _listState$chosaNo === void 0 ? void 0 : _listState$chosaNo.kakuninKekkaCd;
    const currentHyoka = (_listState$chosaNo2 = listState[chosaNo]) === null || _listState$chosaNo2 === void 0 ? void 0 : _listState$chosaNo2.seijukudoHyoka;
    if (kind === _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_YES) {
      if (currentKekka !== _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1) {
        setEntryValueHyoka(chosaNo, 'kakuninKekkaCd', _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1);
        setValue(fieldName('kakuninKekkaCd', chosaNo), _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1, {
          shouldValidate: false,
          shouldDirty: true
        });
      }
    } else if (kind === _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_NO) {
      if (currentKekka !== _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2) {
        setEntryValueHyoka(chosaNo, 'kakuninKekkaCd', _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2);
        setValue(fieldName('kakuninKekkaCd', chosaNo), _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2, {
          shouldValidate: false,
          shouldDirty: true
        });
      }
    } else {
      if (currentHyoka !== value) {
        setEntryValueHyoka(chosaNo, 'seijukudoHyoka', value);
        setValue(fieldName('seijukudoHyoka', chosaNo), value, {
          shouldValidate: false,
          shouldDirty: true
        });
      }
    }
    for (let key in listState) {
      if (listState[key].chosaColumnCd === chosaColumnCd) {
        const isChangedRow = listState[key].chosaNo === chosaNo;
        let effectiveKekkaCd = listState[key].kakuninKekkaCd;
        if (isChangedRow) {
          if (kind === _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_YES) {
            effectiveKekkaCd = _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1;
          } else if (kind === _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_NO) {
            effectiveKekkaCd = _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2;
          }
        }
        if (listState[key].basicAddpointKbnCd === _CodeConsts.CODE.BASE_DEBIT_CD.CODE_1) {
          if (effectiveKekkaCd === _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2) {
            kisoPoint += listState[key].points;
          }
        }
        if (listState[key].basicAddpointKbnCd === _CodeConsts.CODE.BASE_DEBIT_CD.CODE_2) {
          if (effectiveKekkaCd === _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1) {
            katenPoint += listState[key].points;
          }
        }
        if (effectiveKekkaCd === null || effectiveKekkaCd === ' ' || effectiveKekkaCd === '') {
          confirmFlg = false;
        }
      }
    }
    // 成熟度参考値
    const svChosaNo = getChosaNo(chosaNo);
    const newRef = confirmFlg ? standardPoints - kisoPoint + katenPoint : _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU;
    const currentRef = (_listState$svChosaNo = listState[svChosaNo]) === null || _listState$svChosaNo === void 0 ? void 0 : _listState$svChosaNo.referencePoints;
    if (currentRef !== newRef) {
      setEntryValueHyoka(svChosaNo, 'referencePoints', newRef);
    }
  }, [listState, setEntryValueHyoka, setValue]);

  /**
   * 成熟度参考値の設定する調査番号取得
   */
  const getChosaNo = chosaNo => {
    let svChosaNo = 0;
    if (chosaNo <= 5) svChosaNo = 5;else if (chosaNo <= 10) svChosaNo = 10;else if (chosaNo <= 15) svChosaNo = 15;else if (chosaNo <= 20) svChosaNo = 20;else if (chosaNo <= 25) svChosaNo = 25;else svChosaNo = 30;
    return svChosaNo;
  };
  const handleEntryChange = (0, _react.useCallback)((no, key) => value => {
    setValue(fieldName(key, no), value, {
      shouldValidate: false,
      shouldDirty: true
    });
    setEntry(no, key)(value);
  }, [setValue, setEntry]);

  /**
   * 送信（onValid）
   */
  const onValid = (0, _react.useCallback)(() => {
    openConfirmDialog();
  }, [openConfirmDialog]);

  /**
   * 送信（onInvalid）
   */
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);

  /**
   * 基本情報（kansaTgtJigyoBasicInfoが未取得でも安全に初期表示）
   */
  const safeBasicInfo = kansaTgtJigyoBasicInfo || {};
  const basicInfo = (0, _react.useMemo)(() => {
    var _kansaInfo$kansaTgtNe, _safeBasicInfo$kansaT, _safeBasicInfo$kansaB, _safeBasicInfo$kansaS, _safeBasicInfo$kansaT2, _safeBasicInfo$hikans;
    return {
      kansaTgtNendoNm: ((_kansaInfo$kansaTgtNe = kansaInfo === null || kansaInfo === void 0 ? void 0 : kansaInfo.kansaTgtNendo) !== null && _kansaInfo$kansaTgtNe !== void 0 ? _kansaInfo$kansaTgtNe : '') + intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_NENDO
      }),
      kansaThemeNm: (_safeBasicInfo$kansaT = safeBasicInfo.kansaThemeNm) !== null && _safeBasicInfo$kansaT !== void 0 ? _safeBasicInfo$kansaT : '',
      kansaBumonNm: (_safeBasicInfo$kansaB = safeBasicInfo.kansaBumonNm) !== null && _safeBasicInfo$kansaB !== void 0 ? _safeBasicInfo$kansaB : '',
      kansaSekinishaNm: (_safeBasicInfo$kansaS = safeBasicInfo.kansaSekinishaNm) !== null && _safeBasicInfo$kansaS !== void 0 ? _safeBasicInfo$kansaS : '',
      kansaTgtJigyoNm: (_safeBasicInfo$kansaT2 = safeBasicInfo.kansaTgtJigyoNm) !== null && _safeBasicInfo$kansaT2 !== void 0 ? _safeBasicInfo$kansaT2 : '',
      hikansaSekinishaNm: (_safeBasicInfo$hikans = safeBasicInfo.hikansaSekinishaNm) !== null && _safeBasicInfo$hikans !== void 0 ? _safeBasicInfo$hikans : ''
    };
  }, [kansaInfo === null || kansaInfo === void 0 ? void 0 : kansaInfo.kansaTgtNendo, intl, safeBasicInfo.kansaThemeNm, safeBasicInfo.kansaBumonNm, safeBasicInfo.kansaSekinishaNm, safeBasicInfo.kansaTgtJigyoNm, safeBasicInfo.hikansaSekinishaNm]);

  /**
   * 検索結果ヘッダ（監査回答）
   */
  const columns = (0, _react.useMemo)(() => [{
    dataKey: 'kakuninJiko',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KAKUNIN_JIKO
    }),
    width: 450
  }, {
    dataKey: 'kakuninKekkaCd',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KAKUNIN_KEKKA
    }),
    hint: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_ANSWER_KEKKA_HINT
    }),
    width: 170
  }, {
    dataKey: 'kakuninHosoku',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KAKUNIN_HOSOKU
    }),
    width: 370
  }, {
    dataKey: 'hakkenjikoBunruiCd',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HAKKEN_JIKO_BUNRUI
    }),
    hint: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_ANSWER_HAKKENJIKO_HINT
    }),
    width: 250
  }, {
    dataKey: 'hakkenjiko',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HAKKEN_JIKO
    }),
    width: 370
  }, {
    dataKey: 'seijukudoHyoka',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
    }),
    hint: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_ANSWER_SEIJUKUDO_HINT
    }),
    width: 200
  }], [intl]);
  const hakkenjikoBunruiItems = (0, _react.useMemo)(() => getCodeItems(_CodeConsts.CODE.KANSA_HKN_BNR.KBN), [getCodeItems]);

  /**
   * 検索結果ボディ生成
   */
  const createRow = (0, _react.useCallback)(data => {
    // ヘッダレコードの場合（調査項目別）
    if (data.recordKbn === _KansaAnswerConsts.CONSTS.REC_HEAD_KBN) {
      const kakuninJiko = data.kakuninJiko;
      return {
        kakuninJiko
      };
      // 明細レコードの場合
    } else {
      var _errors$fKekka, _errors$fHosoku, _errors$fBunrui, _errors$fHakken, _errors$fHyoka;
      const no = data.chosaNo;
      const fHosoku = fieldName('kakuninHosoku', no);
      const fBunrui = fieldName('hakkenjikoBunruiCd', no);
      const fHakken = fieldName('hakkenjiko', no);
      const fHyoka = fieldName('seijukudoHyoka', no);
      const fKekka = fieldName('kakuninKekkaCd', no);
      const kakuninJiko = _stringUtil.default.emptyToHyphen(listState[no].kakuninJiko);
      const kakushoExp = _stringUtil.default.emptyToHyphen(listState[no].kakushoExp);
      const kakuninKekkaCd = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_KakuninKekka.default, {
        listState: listState,
        chosaNo: no,
        value: listState[no].kakuninKekkaCd,
        labelYes: getCodeName(_CodeConsts.CODE.KANSA_KKNN_RSLT.KBN, _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1),
        labelNo: getCodeName(_CodeConsts.CODE.KANSA_KKNN_RSLT.KBN, _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2),
        onChange: pointCalc,
        error: !!errors[fKekka],
        helperText: (_errors$fKekka = errors[fKekka]) === null || _errors$fKekka === void 0 ? void 0 : _errors$fKekka.message
      }));
      const kakuninHosoku = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: listState[no].kakuninHosoku,
        onChange: handleEntryChange(no, 'kakuninHosoku'),
        multiline: true,
        rows: 4,
        maxLength: 200,
        error: !!errors[fHosoku],
        helperText: (_errors$fHosoku = errors[fHosoku]) === null || _errors$fHosoku === void 0 ? void 0 : _errors$fHosoku.message
      });
      const hakkenjikoBunruiCd = /*#__PURE__*/_react.default.createElement(_CSelect.default, {
        value: listState[no].hakkenjikoBunruiCd,
        onChange: handleEntryChange(no, 'hakkenjikoBunruiCd'),
        items: hakkenjikoBunruiItems,
        setNone: false,
        error: !!errors[fBunrui],
        helperText: (_errors$fBunrui = errors[fBunrui]) === null || _errors$fBunrui === void 0 ? void 0 : _errors$fBunrui.message
      });
      const hakkenjiko = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: listState[no].hakkenjiko,
        onChange: handleEntryChange(no, 'hakkenjiko'),
        multiline: true,
        rows: 4,
        maxLength: 200,
        error: !!errors[fHakken],
        helperText: (_errors$fHakken = errors[fHakken]) === null || _errors$fHakken === void 0 ? void 0 : _errors$fHakken.message
      });
      const seijukudoHyoka = /*#__PURE__*/_react.default.createElement(_material.Grid, {
        container: true
      }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        size: {
          xs: 12
        }
      }, intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_REFERENCE_VALUE
      }), listState[no].referencePoints === '' ? data.referencePoints : listState[no].referencePoints), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        size: {
          xs: 12
        }
      }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        size: {
          xs: 12
        }
      }, intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_VALUE
      })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        size: {
          xs: 12
        }
      }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: listState[no].seijukudoHyoka,
        onChange: handleEntryChange(no, 'seijukudoHyoka'),
        maxLength: 4,
        error: !!errors[fHyoka],
        helperText: (_errors$fHyoka = errors[fHyoka]) === null || _errors$fHyoka === void 0 ? void 0 : _errors$fHyoka.message
      }))));
      if (data.dispFlg) {
        return {
          kakuninJiko,
          kakushoExp,
          kakuninKekkaCd,
          kakuninHosoku,
          hakkenjikoBunruiCd,
          hakkenjiko,
          seijukudoHyoka
        };
      } else {
        return {
          kakuninJiko,
          kakushoExp,
          kakuninKekkaCd,
          kakuninHosoku,
          hakkenjikoBunruiCd,
          hakkenjiko
        };
      }
    }
  }, [listState, getCodeName, intl, errors, handleEntryChange, pointCalc, hakkenjikoBunruiItems]);

  /**
   * 画面構成
   */
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_ANSWER_REGISTER
    }),
    help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.KANSA_KANSA_ANSWER_REGISTER_HELP
    })
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 10
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
    data: basicInfo
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 2
    },
    align: "left"
  }, (() => {
    if (zennendoSimpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1 && zennendoKansaAnsStsCd === _CodeConsts.CODE.KANSA_ANS_STS.CODE_3) {
      return /*#__PURE__*/_react.default.createElement(StyledPreviousButton, {
        autoWidth: true,
        onClick: onClickOverridePreviousEntries
      }, intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_LASTYEAR_KANSA_ANSWER_SHOW
      }));
    }
  })())), /*#__PURE__*/_react.default.createElement(_AnswerTable.default, {
    key: submitCount,
    columns: columns,
    rowData: svData,
    createRow: createRow
  }), /*#__PURE__*/_react.default.createElement(_KansaAnswerTrailList.default, null), mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2 && /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PUSH_COMPLETE_REGISTER
    }),
    required: true,
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_PUSH_MAIL
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    })
  }), /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
    checked: (entries === null || entries === void 0 ? void 0 : entries.pushFlg) || false,
    onChange: changePushFlg,
    required: true,
    shiftLeft: true
  })))), /*#__PURE__*/_react.default.createElement(StyledCardActions, {
    disableSpacing: true
  }, /*#__PURE__*/_react.default.createElement(_ButtonFooter.default, {
    gyomuCd: gyomuCd,
    kansaAnsStsCd: kansaTgtJigyoBasicInfo === null || kansaTgtJigyoBasicInfo === void 0 ? void 0 : kansaTgtJigyoBasicInfo.kansaAnsStsCd,
    btnClick: onButtonClick,
    returnBtn: returnBtn
  }))));
}
const mapStateToProps = state => {
  return {
    entries: state.kansaAnswer.entries,
    kansaInfo: state.kansaAnswer.kansaInfo,
    previousEntries: state.kansaAnswer.previousEntries,
    listState: state.kansaAnswer.listState,
    entryResult: state.kansaAnswer.entryResult,
    setEntryResult: state.kansaAnswer.setEntryResult,
    searchTrailResult: state.kansaAnswer.searchTrailResult,
    mailFlg: state.coreLoginInfo.mailFlg,
    gyomuCd: state.kansaAnswer.searchConditions.gyomuCd,
    kansaTgtNendoMaxPoints: state.kansaAnswer.kansaTgtNendoMaxPoints,
    kansaTgtJigyoBasicInfo: state.kansaAnswer.kansaTgtJigyoBasicInfo,
    isProgress: state.kansaAnswer.isProgress
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (dataId, key, value) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY](dataId, key, value)),
    setEntryResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY_RESULT](resultList)),
    setSearchTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_TRAIL_RESULT](resultList)),
    setEntry: (dataId, key) => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY](dataId, key, value));
    },
    setEntryValue: (dataId, key, item) => () => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY](dataId, key, item));
    },
    setEntryValueHyoka: (dataId, key, item) => {
      dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY](dataId, key, item));
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
    },
    setContent: content => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_CONTENT](content)),
    setRegisterDt: dt => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false));
      dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_REGISTER_DT](dt));
    },
    changePushFlg: flg => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_PUSH_FLG](flg)),
    setMailErrMsg: mailErrMsg => {
      dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_MAIL_ERR_MSG](mailErrMsg));
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    clearDirty: () => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false)),
    goMain: search => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_MAIN](search)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo)),
    goProgressMain: search => dispatch(_kansaProgressActions.kansaProgressActions[_kansaProgressActions.TYPES.GO_MAIN](search))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerRegisterEntry))));